import { IconButton, Stack, useTheme } from "@mui/material";
import { ArrowLeftIcon } from "lucide-react";
import type { ReactNode } from "react";
import { usePortfolioRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { MyPlannTopBarRedesign } from "web_myplann/Shared/Components/Redesign/MyPlannTopBarRedesign";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import { useGoBack } from "web_myplann/Shared/Hooks/useGoBack";
import { useRedirectGuard } from "web_myplann/Shared/Hooks/useRedirectGuard";

type Props = {
	title: string;
	children: ReactNode;
};

export const PortfolioAddLayout = ({ title, children }: Props) => {
	const theme = useTheme();
	const hasPortfolioRight = usePortfolioRightOptional();
	useRedirectGuard(!hasPortfolioRight, Routing.Portfolio.PortfolioList.path());
	const navigateBack = useGoBack(Routing.Portfolio.PortfolioAddItem.path());

	return (
		<MyPlannLayout
			disableContentPadding
			bgColor={theme.palette.grey[50]}
			topBarBgColor={theme.palette.background.paper}
			topBar={
				<Stack
					sx={{
						width: "100%",
						bgcolor: theme.palette.background.paper,
					}}
				>
					<MyPlannTopBarRedesign
						title={title}
						startComponent={
							<IconButton onClick={navigateBack}>
								<ArrowLeftIcon
									size={theme.iconSize.md}
									color={theme.palette.grey[900]}
								/>
							</IconButton>
						}
					/>
				</Stack>
			}
		>
			{children}
		</MyPlannLayout>
	);
};
